import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GetCountries } from "../../../api/masters/countryAPI";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetStates } from "../../../api/masters/stateAPI";
import { BulkImportCity, StoreCity } from "../../../api/masters/cityAPI";
import BulkImport from "../../../components/BulkImport";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  countryId: yup.string().required("Country is required"),
  stateId: yup.string().required("State is required")
});

const AddCity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchCountry = async () => {
    try {
      const response = await GetCountries(); // Make sure login function returns token
      if (response.success) {
        setCountries(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  const fetchStates = async countryId => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await GetStates(countryId); // Make sure login function returns token
      if (response.success) {
        setStates(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  // Fetch existing data
  useEffect(() => {
    const loadData = async () => {
      try {
        dispatch({ type: "LOADER_START" });

        await fetchCountry();
      } catch (error) {
        showToast("error", error);
      } finally {
        dispatch({ type: "LOADER_STOP" });
      }
    };

    loadData();
  }, []);

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreCity(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/masters/city/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  const bulkColumns = [
    { key: "name", label: "City Name", sample: "Mumbai" },
    { key: "country", label: "Country", sample: "India" },
    { key: "state", label: "State", sample: "Maharashtra" }
  ];

  const handleBulkImport = async payload => {
    const response = await BulkImportCity(payload);

    if (response.success) {
      showToast("success", response.message);
      navigate("/masters/city/list");
    } else {
      showToast("error", response.message);
    }
  };

  return (
    <Fragment>
      <Breadcrumb parent="City" title="Add City" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Add City</h5>
                  <Link to={`/masters/city/list`}>
                    <button className="btn btn-primary" id="list">
                      List City
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List City
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Select Country*</label>
                        <select
                          className="form-select"
                          id="name"
                          type="text"
                          {...register("countryId")}
                          onChange={e => {
                            fetchStates(e.target.value);
                          }}
                        >
                          <option value="">Select Country</option>
                          {countries.map(country =>
                            <option value={country._id}>
                              {country.name}
                            </option>
                          )}
                        </select>
                        {errors.countryId &&
                          <p className="text-danger">
                            {errors.countryId.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Select State*</label>
                        <select
                          className="form-select"
                          id="name"
                          type="text"
                          {...register("stateId")}
                        >
                          <option value="">Select State</option>
                          {states.map(state =>
                            <option value={state._id}>
                              {state.name}
                            </option>
                          )}
                        </select>
                        {errors.stateId &&
                          <p className="text-danger">
                            {errors.stateId.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">City Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="City Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <BulkImport
              columns={bulkColumns}
              onSubmit={handleBulkImport}
              payloadKey="cities"
              sampleFileName="citie_sample.csv"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddCity;
